// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileCard-profileCardTitle-GQn1H {
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  color: var(--primary-foreground);
  margin-top: 18px;
  margin-bottom: 3px;
}

.ProfileCard-profileCardName-UDM_K {
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  color: var(--primary-foreground);
  margin-bottom: 18px;
}

.ProfileCard-profilePhoneNumberSection-MhpHP {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 6px 12px;
  background-color: var(--primary-gray-bg);
  border-radius: 100px;
  gap: 6px;
}

.ProfileCard-defaultPhoneIcon-jJsu1 {
  position: relative;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
}

.ProfileCard-profileCardWrapper-UUzfE {
  background: var(--background-primary);
  -webkit-box-shadow: 0px 14px 40px 0px var(--shadow-6);
          box-shadow: 0px 14px 40px 0px var(--shadow-6);
  padding: 42px 24px;
  border-radius: var(--radius-3);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.ProfileCard-profileCardContainer-Psc3s {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 24px;
}

.ProfileCard-createBookingCard-nzrzC {
  padding: 24px;
  border-radius: var(--radius-3);
  background: var(--background-primary);
  -webkit-box-shadow: 0px 14px 40px 0px var(--shadow-6);
          box-shadow: 0px 14px 40px 0px var(--shadow-6);
  cursor: pointer;
}

.ProfileCard-createBookingCardWrapper-OBh37 {
  padding: 24px 18px;
  background: var(--background-secondary);
  border-radius: var(--radius-2);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 12px;
  grid-gap: 12px;
  color: var(--primary-foreground);
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
}

.ProfileCard-createBookingCardIconContainer-hxMbJ {
  background: var(--primary-bg);
  width: 45px;
  height: 45px;
  border-radius: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

@media (min-width:992px) {
  .ProfileCard-profileCardContainer-Psc3s {
    position: sticky;
    top: 187px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ProfileCard/ProfileCard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,qDAA6C;UAA7C,6CAA6C;EAC7C,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,qDAA6C;UAA7C,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,8BAA8B;EAC9B,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF","sourcesContent":[".profileCardTitle {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--primary-foreground);\n  margin-top: 18px;\n  margin-bottom: 3px;\n}\n\n.profileCardName {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 30px;\n  color: var(--primary-foreground);\n  margin-bottom: 18px;\n}\n\n.profilePhoneNumberSection {\n  display: flex;\n  align-items: center;\n  padding: 6px 12px;\n  background-color: var(--primary-gray-bg);\n  border-radius: 100px;\n  gap: 6px;\n}\n\n.defaultPhoneIcon {\n  position: relative;\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  min-height: 16px;\n}\n\n.profileCardWrapper {\n  background: var(--background-primary);\n  box-shadow: 0px 14px 40px 0px var(--shadow-6);\n  padding: 42px 24px;\n  border-radius: var(--radius-3);\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.profileCardContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.createBookingCard {\n  padding: 24px;\n  border-radius: var(--radius-3);\n  background: var(--background-primary);\n  box-shadow: 0px 14px 40px 0px var(--shadow-6);\n  cursor: pointer;\n}\n\n.createBookingCardWrapper {\n  padding: 24px 18px;\n  background: var(--background-secondary);\n  border-radius: var(--radius-2);\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  gap: 12px;\n  grid-gap: 12px;\n  color: var(--primary-foreground);\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: 400;\n}\n\n.createBookingCardIconContainer {\n  background: var(--primary-bg);\n  width: 45px;\n  height: 45px;\n  border-radius: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (min-width:992px) {\n  .profileCardContainer {\n    position: sticky;\n    top: 187px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileCardTitle": `ProfileCard-profileCardTitle-GQn1H`,
	"profileCardName": `ProfileCard-profileCardName-UDM_K`,
	"profilePhoneNumberSection": `ProfileCard-profilePhoneNumberSection-MhpHP`,
	"defaultPhoneIcon": `ProfileCard-defaultPhoneIcon-jJsu1`,
	"profileCardWrapper": `ProfileCard-profileCardWrapper-UUzfE`,
	"profileCardContainer": `ProfileCard-profileCardContainer-Psc3s`,
	"createBookingCard": `ProfileCard-createBookingCard-nzrzC`,
	"createBookingCardWrapper": `ProfileCard-createBookingCardWrapper-OBh37`,
	"createBookingCardIconContainer": `ProfileCard-createBookingCardIconContainer-hxMbJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
